import { Wrench } from "lucide-react";
import { Link } from "react-router-dom";
import Countdown from "@/components/Countdown";

export default function Maintenance({ settings }) {
  const maint = settings?.maintenance || {};
  const bgImg = settings?.branding?.maintenance_bg_image;
  return (
    <div
      data-testid="maintenance-screen"
      className="min-h-screen bg-[#121214] checkered-fade flex flex-col"
      style={
        bgImg
          ? {
              backgroundImage: `linear-gradient(rgba(18,18,20,0.85), rgba(18,18,20,0.95)), url(${bgImg})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }
          : undefined
      }
    >
      <div className="checkered-strip" />
      <div className="flex-1 flex flex-col items-center justify-center px-6 text-center">
        <Wrench className="w-12 h-12 text-[#FFB703] mb-6" />
        <p className="font-body-sport text-[10px] font-bold tracking-[0.4em] text-[#FF1E27] uppercase">
          Dinamika APS
        </p>
        <h1 className="font-racing font-black text-3xl sm:text-5xl uppercase text-white mt-3 leading-tight">
          I Banchi Prova
          <br />
          sono in Corso<span className="text-[#FF1E27]">...</span>
        </h1>
        <p className="text-gray-400 mt-6 max-w-md text-sm leading-relaxed" data-testid="maintenance-message">
          {maint.message || "Stiamo aggiornando le classifiche ufficiali della 69° Salita dei Monti Iblei."}
        </p>
        {maint.reopen_at && (
          <div className="mt-8">
            <Countdown target={maint.reopen_at} label="Riapertura prevista tra" />
          </div>
        )}
        <Link
          to="/login"
          className="mt-10 text-[10px] font-body-sport tracking-widest text-gray-600 hover:text-gray-400 uppercase"
        >
          Accesso amministratori
        </Link>
      </div>
      <div className="checkered-strip" />
    </div>
  );
}
